import React from 'react'

function Footer() {
  return (
    <div>
     <footer className="main-footer @@extraClassName">
  <div className="main-footer__bg" style={{backgroundImage: 'url(assets/images/backgrounds/footer-bg.png)'}} />
  {/* /.main-footer__bg */}
  <div className="container">
    <div className="main-footer__top row">
      <div className="col-lg-4 col-sm-5">
        <div className="main-footer__logo-box">
        <img src="assets/images/logoo.png" alt="Trevlo HTML" width={150}/>
              {/* <span className='text-white fs-5 fw-semibold'>Al Qadir Aviation</span> */}
        </div>{/* /.main-footer__logo-box */}
      </div>
      <div className="col-lg-8 col-sm-7">
        <ul className="main-footer__social">
          <li className="main-footer__social-item">
            <a href="https://facebook.com" className="main-footer__social-link"><i className="fab fa-facebook-f" /></a>
          </li>
          <li className="main-footer__social-item">
            <a href="https://linkedin.com" className="main-footer__social-link"><i className="fab fa-linkedin-in" /></a>
          </li>
          <li className="main-footer__social-item">
            <a href="https://twitter.com" className="main-footer__social-link"><i className="fab fa-twitter" /></a>
          </li>
          <li className="main-footer__social-item">
            <a href="https://youtube.com" className="main-footer__social-link"><i className="fab fa-youtube" /></a>
          </li>
        </ul>{/* /.main-footer__logo-box */}
      </div>
      <div className="col-12">
        <div className="main-footer__line" />{/* /.main-footer__line */}
      </div>{/* /.col-12 */}
    </div>{/* /.main-footer__top */}
    <div className="row">
      <div className="col-lg-3 col-md-4 col-sm-6 col-xl-2 wow animated fadeInUp" data-wow-delay="0.1s" data-wow-duration="1500ms">
        <div className="footer-widget footer-widget--links">
          <h2 className="footer-widget__title">Company</h2>{/* /.footer-widget__title */}
          <ul className="footer-widget__links">
            <li><a href="/aboutus">About Us</a></li>
            <li><a href="/contactus">Contact Us</a></li>
            <li><a href="/umrah">Umrah</a></li>
            <li><a href="/hotels">Hotels</a></li>
            {/* <li><a href="contact.html">Contact Now</a></li> */}
          </ul>{/* /.footer-widget__links */}
        </div>{/* /.footer-widget */}
      </div>{/* /.col-md-6 */}

      <div className="col-lg-6 col-md-4 col-xl-4 wow animated fadeInUp" data-wow-delay="0.5s" data-wow-duration="1500ms">
        <div className="footer-widget footer-widget--contact">
          <h2 className="footer-widget__title">Contact Us</h2>{/* /.footer-widget__title */}
          <p className="footer-widget__address">UG-143 Al Rehman Trade Center University Road,Sargodha, Pakistan</p>
          <ul className="footer-widget__info">
            <li> <span className="icon-phone-1" /> <a href="tel:(+92)3224070193">+923216051218</a></li>
            <li> <span className="icon-envelope" /> <a href="mailto:alqadiraviation@gmail.com">alqadiraviation@gmail.com</a></li>
          </ul>{/* /.footer-widget__info */}
        </div>{/* /.footer-widget */}
      </div>{/* /.col-md-6 */}
     
      {/* /.col-md-6 */}
    </div>{/* /.row */}
  </div>{/* /.container */}
  <div className="main-footer__bottom">
    <div className="container">
      <div className="main-footer__bottom-inner">
        <p className="main-footer__copyright">
          © Copyright <span className="dynamic-year" /> by Code Loop Technology
        </p>
      </div>{/* /.main-footer__inner */}
    </div>{/* /.container */}
  </div>{/* /.main-footer__bottom */}
</footer>{/* /.main-footer */}

    </div>
  )
}

export default Footer
